import { Box } from '@mui/system';
import React from 'react';
import { ClinicalReviewActivityModel } from '../../../lib/models/ClinicalReviewActivityModel';
import { BoldTextBox, SmallerBoldTextBox, SmallerTextBox } from '../../../styledComponents';
import crmNewLineReplacer from '../../../lib/helper/crm-new-line-replacer';
import formatNewLines from '../../../lib/helper/format-new-lines';

export type ClinicalReviewActivityItemProps = {
    item: ClinicalReviewActivityModel;
    mediaSm: boolean;
};

const InitialReviewActivity = ({ item, mediaSm }: ClinicalReviewActivityItemProps) => (
    <>
        {item.nurseConclusions || item.comorbidityIndexScore ? (
            <Box sx={!mediaSm ? { padding: '0.938rem 0' } : { padding: '0 0.75rem' }}>
                <BoldTextBox>Nurse review Comments</BoldTextBox>
                <SmallerBoldTextBox>Reviewed By {item.nurseName}</SmallerBoldTextBox>
                <SmallerTextBox>{formatNewLines(item.nurseConclusions)}</SmallerTextBox>
                <SmallerTextBox>
                    <b>Comorbidity Index Score: {item.comorbidityIndexScore}</b>
                </SmallerTextBox>

                {item.prosthetics && (
                    <SmallerTextBox>
                        Implant Information (Prosthetics): {item.prosthetics}
                    </SmallerTextBox>
                )}
                {item.medicalDevices && (
                    <SmallerTextBox>
                        Implant Information (Medical Devices): {item.medicalDevices}
                    </SmallerTextBox>
                )}
                {item.instrumentation && (
                    <SmallerTextBox>
                        Implant Information (Instrumentation): {item.instrumentation}
                    </SmallerTextBox>
                )}
                {item.grafts && (
                    <SmallerTextBox>Implant Information (Grafts): {item.grafts}</SmallerTextBox>
                )}
            </Box>
        ) : null}

        {item.nurseDecision ? (
            <Box sx={!mediaSm ? { paddingBottom: '0.938rem' } : { padding: '0 0.75rem' }}>
                <BoldTextBox>Nurse Conclusions</BoldTextBox>
                <SmallerBoldTextBox>Reviewed By {item.nurseName}</SmallerBoldTextBox>
                <SmallerTextBox>{item.nurseDecision}</SmallerTextBox>
            </Box>
        ) : null}

        {item.physicianName ? (
            <Box sx={!mediaSm ? { paddingBottom: '0.938rem' } : { padding: '0 0.75rem' }}>
                <BoldTextBox>Initial Physician Review Rational Conclusion</BoldTextBox>
                {/* <SmallerBoldTextBox>Reviewed By {item.physicianName}</SmallerBoldTextBox> */}
                <SmallerTextBox>{crmNewLineReplacer(item.physicianReview)}</SmallerTextBox>
                {item.isAppAppropriateValue && (
                    <>
                        <SmallerTextBox>
                            APP Appropriate: {item.isAppAppropriateValue}
                        </SmallerTextBox>
                        {item.isAppAppropriateValue === 'Yes' && (
                            <SmallerTextBox>APP Reason: {item.appP2PReason}</SmallerTextBox>
                        )}
                    </>
                )}
                {item.spanishPhysicianReview ? (
                    <>
                        <BoldTextBox>
                            Initial Physician Review Rational Conclusion (Spanish)
                        </BoldTextBox>
                        <SmallerTextBox>
                            {crmNewLineReplacer(item.spanishPhysicianReview)}
                        </SmallerTextBox>
                    </>
                ) : null}
            </Box>
        ) : null}
    </>
);

export default InitialReviewActivity;
